var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.099,
    height: 18.143,
    viewBox: "30.495 198 36.099 18.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 1829"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 1122"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 1191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.858 198c-5.25 0-9.363 3.97-9.363 9.038 0 5.106 4.112 9.105 9.363 9.105 5.231 0 9.329-4 9.329-9.105 0-5.068-4.098-9.038-9.33-9.038m0 14.678c-3.144 0-5.702-2.53-5.702-5.64 0-3.072 2.558-5.573 5.703-5.573 3.178 0 5.669 2.448 5.669 5.573 0 3.163-2.49 5.64-5.67 5.64",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.266 199.794h-9.46a.372.372 0 0 0-.262.637 9.162 9.162 0 0 1 2.742 6.581c0 2.54-.978 4.902-2.752 6.654a.372.372 0 0 0 .263.636h9.469c4.04 0 7.328-3.254 7.328-7.254 0-4-3.287-7.254-7.328-7.254",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6467"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logoIcon.7c6f3421a40e500f9d3946413d7edc64.svg";
export { ForwardRef as ReactComponent };